<script setup>
import {ref} from "vue";
import aiChatLogsService from "@/services/ai-chat-logs.service";

const showModal = ref(false);
const conversationId = ref(null);
const rounds = ref([]);

function sanitizeAnswer(answer) {
    return answer
        .replace(/\\r\\n|\\n|\\r/g, '<br>')
        .replace(/\r\n|\n|\r/g, '<br>');
}

async function getMessages() {
    const {data} = await aiChatLogsService.getMessages(conversationId.value);
    rounds.value = data;
}

function open(id) {
    rounds.value = [];
    conversationId.value = id;
    getMessages();

    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" hide-footer hide-header modal-class="modal-ai-chat">
        <!-- <a href="#" class="close">Back</a> -->
        <section class="section-ai-chat">
            <button @click="showModal = false" type="button" aria-label="Close" class="close"></button>

            <div class="ai-chat__inner">
                <div class="ai-chat__content">
                    <div
                        v-for="(messages, index) in rounds"
                        :key="index"
                        class="ai-chat"
                    >
                        <template v-for="message in messages">
                            <div v-if="message.sender === 'user'" class="ai-chat__user" :key="message.id">
                                {{message.question}}
                            </div>

                            <div v-if="message.sender === 'assistant'" class="ai-chat__machine" :key="message.id">
                                <template v-if="message.response_type === 'answer'">
                                    <p v-if="message.answer" v-html="sanitizeAnswer(message.answer)"/>
                                </template>

                                <div v-else-if="message.response_type === 'data_request'">
                                    Data Requested
                                </div>

                                <div>
                                    <a class="link" v-b-toggle="`data-request-${message.id}`">Raw Response</a>
                                    <b-collapse :id="`data-request-${message.id}`" class="mt-2">
                                        <pre><code>{{message.raw_response}}</code></pre>
                                    </b-collapse>
                                </div>

                                <div v-if="message.sql_query">
                                    <a class="link" v-b-toggle="`sql-query-${message.id}`">SQL query</a>
                                    <b-collapse :id="`sql-query-${message.id}`" class="mt-2">
                                        <code>{{message.sql_query}}</code>
                                    </b-collapse>
                                </div>
                            </div>

                            <div v-if="message.sender === 'system'" class="ai-chat__system" :key="message.id">
                                <div v-if="message.system_request">
                                    <a class="link" v-b-toggle="`system-request-${message.id}`">System response</a>
                                    <b-collapse :id="`system-request-${message.id}`" class="mt-2">
                                        <pre><code>{{message.system_request}}</code></pre>
                                    </b-collapse>
                                </div>
                            </div>

                            <div
                                v-if="message.error_message"
                                :key="`error-${message.id}`"
                                class="error-message"
                            >
                                {{message.error_message}}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>
    </b-modal>
</template>

<style scoped>
    .error-message {
        color: red;
    }

    .ai-chat__system {
        align-self: flex-end;
    }
</style>
